export default {
    red: 'exclamation circle',
    teal: 'check circle',
  }